module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Home/Towel-411380b797b1d3874d6b8fd5765e01d9.svg";